import { getAll } from '../utilities/querySelector.js';

getAll('button[data-next-section], a[data-next-section]').forEach((btn) => {
    btn.addEventListener('click', handleNavigation);
});

function handleNavigation(e) {
    const currentSection = e.currentTarget.closest('section');
    const nextSection = currentSection.nextElementSibling;
    if (nextSection) {
        nextSection.scrollIntoView({ behavior: 'smooth' });
    }
}
